<template>

      <v-flex xs12 text-center>
        <v-card flat :to="to" hover>
          <v-sheet height="120" text-center class="card-container">
            <div class="txt-container">
              <v-icon class="mr-1 ml-auto" size="35" :color="color" >{{icon}}</v-icon>
              <div class="qty">{{cuenta}}</div>
              <div class="label hidden-sm-and-down">{{linea2}}</div>
              <div class="label-mobile hidden-md-and-up">{{linea2}}</div>
            </div>

          </v-sheet>
        </v-card>
      </v-flex>

</template>
<script>
export default {
  props: {
    to: {
      type: Object,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    linea2: {
      type: String,
      required: true
    },
    cuenta: {
      type: Number,
      required: true
    },
    botonTexto: {
      type: String,
    },
    color: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      hover: false
    }
  },
}
</script>

<style scoped>

  .avatar-card{
    left: 0;
    position: absolute;
  }

  .txt-container{
    text-align: left;
    display: flex;
    align-items: center;
    height: 100%
  }

  .qty{
    flex: .25;
    text-align: end;
    padding: 5px;
    font-size: 2.5em;
    font-weight: bold;
  }

  .label{
    flex: 3;
    padding-left: 5px;
    font-size: .9em;
    border-left: 4px solid #e4e4e4;
  }

  .label-mobile{
    flex: 2.5;
    padding-left: 10px;
    font-size: 1.2em;
    font-weight: 300;
    border-left: 4px solid #e4e4e4;
  }

  .card-container{
    width: 96%;
    margin: auto;
    border-radius: 10px;
    padding: 10px;
    background-color: rgba(255,255,255,.7);
  }

p {
  margin-bottom: 0;
  font-size: 15px;
}
h4 {
  font-size: 30px;
}
</style>
